module.exports = __webpack_public_path__ + "img/slide1.0038a1c4.png";